import { useEffect, useRef, useCallback } from 'react';

export function useWebSocket(onMessage) {
  const ws       = useRef(null);
  const timer    = useRef(null);
  const onMsgRef = useRef(onMessage);
  onMsgRef.current = onMessage;

  const connect = useCallback(() => {
    const proto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    // In dev, CRA runs on :3000 but WS server is on :3001
    const port = process.env.NODE_ENV === 'development' ? '3001' : window.location.port;
    const host = window.location.hostname;
    const url  = `${proto}://${host}${port ? ':' + port : ''}`;

    const socket = new WebSocket(url);
    ws.current = socket;

    socket.onopen = () => {
      clearTimeout(timer.current);
    };

    socket.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        onMsgRef.current?.(data);
      } catch {}
    };

    socket.onclose = () => {
      timer.current = setTimeout(connect, 5000);
    };

    socket.onerror = () => socket.close();
  }, []);

  useEffect(() => {
    connect();
    return () => {
      clearTimeout(timer.current);
      ws.current?.close();
    };
  }, [connect]);
}
